<template>
  <div class="header">
    <img :src="data.icon" alt="" class="headerLogo" />
    <div class="title-box">
      <div class="text">{{ data.title }}</div>
      <div class="text">{{ data.desc }}</div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
      type: Object,
      default: () => {
          return {}
      }
  }
})
</script>

<style lang="scss" scoped>
  .header {
    padding: 20px 20px 0;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    img{
      height: 26px;
      width: 26px;
    }
    .title-box{
      display: flex;
      flex-direction: column;
      margin-left: 6px;
      .text{
        font-size: 8px;
        color: rgb(255, 255, 255);
        font-family: 360shouhu Type;
      }
    }
  }
</style>
